import axios from "axios";
// import { setupCache } from "axios-cache-interceptor";

// const axios = setupCache(Axios);

const API = axios.create({
  baseURL:
  "https://ideoqoi3j4.execute-api.us-east-1.amazonaws.com/production/api",
   //baseURL: "http://localhost:5000/api",
  // Mumbai region
  // baseURL:
  //   "https://uvjay4br6k.execute-api.ap-south-1.amazonaws.com/production/api",
  timeout: 60000,
});
export default API;
